import { computed, watchEffect } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export function usePageTitle() {
  const route = useRoute()
  const router = useRouter()

  const pageTitle = computed(() => {
    const matchingRoute = router
      .getRoutes()
      .filter((r) => r.meta?.title && route.path.startsWith(r.path))
      .sort((a, b) => b.path.length - a.path.length)[0]

    const rawTitle = matchingRoute?.meta.title
    return typeof rawTitle === 'function' ? rawTitle() : rawTitle || 'Atlast Admin'
  })

  watchEffect(() => {
    document.title = `${pageTitle.value} | Atlast Admin`
  })

  return { pageTitle }
}
